import React, { useState, useEffect } from "react";
import BASE_URL from "../../../config/config";
import { useNavigate } from "react-router-dom";
// import "../../../css/admin.module.css";

// وضعیت به رنگ
function getStatusColor(status) {
  switch (status) {
    case "canceled": return "error";
    case "completed": return "success";
    case "pending": return "warning";
    case "paid": return "info";
    default: return "secondary";
  }
}
function translateStatus(status) {
  switch (status) {
    case "canceled": return "رد شده";
    case "completed": return "تکمیل شده";
    case "pending": return "در انتظار";
    case "paid": return "پرداخت شده";
    default: return status;
  }
}
const serviceTypeLabels = {
  graphic_design: "گرافیک",
  programming: "برنامه‌نویسی",
  web_design: "طراحی وب",
  course: "دوره آموزشی",
};

const OrderListManagement = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // صفحه‌بندی
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  // جستجو
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searching, setSearching] = useState(false);

  // مرتب‌سازی
  const [sortField, setSortField] = useState("created_at");
  const [sortDirection, setSortDirection] = useState("desc");

  const [csrfToken, setCsrfToken] = useState("");
  const [orderMessage, setOrderMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const res = await fetch(`${BASE_URL}/csrf-token`, { credentials: "include" });
        const data = await res.json();
        setCsrfToken(data.csrfToken);
      } catch {
        setError("دریافت توکن امنیتی با خطا");
      }
    };
    fetchToken();
  }, []);

  useEffect(() => {
    if (csrfToken) fetchOrders();
    // eslint-disable-next-line
  }, [csrfToken, currentPage, searchQuery, sortField, sortDirection]);

  // گرفتن لیست سفارشات
  const fetchOrders = async () => {
    setLoading(true);
    try {
      let url = `${BASE_URL}/orders?page=${currentPage}&limit=${itemsPerPage}`;
      if (searchQuery) url += `&search=${encodeURIComponent(searchQuery)}`;
      url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "CSRF-Token": csrfToken,
        },
        credentials: "include",
      });
      if (!response.ok) throw new Error("خطا در دریافت سفارشات");
      const data = await response.json();
      setOrders(data.data.orders || []);
      setTotalPages(data.data.pagination?.totalPages || 1);
      setLoading(false);
      setSearching(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setSearching(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchQuery(searchInput);
    setCurrentPage(1);
    setSearching(true);
  };

  const clearSearch = () => {
    setSearchInput("");
    setSearchQuery("");
    setCurrentPage(1);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  // عملیات (ویرایش/حذف)
  const handleEditOrder = (order) => {
    navigate(`/admin/orders/edit/${order.id}`);
  };
  const handleDeleteOrder = async (orderId) => {
    if (window.confirm("آیا از حذف این سفارش مطمئن هستید؟")) {
      try {
        const res = await fetch(`${BASE_URL}/orders/${orderId}`, {
          method: "DELETE",
          headers: {
            "CSRF-Token": csrfToken,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          credentials: "include",
        });
        const data = await res.json();
        if (res.ok) {
          setOrders((prev) => prev.filter((order) => order.id !== orderId));
          setOrderMessage(data.message || "سفارش با موفقیت حذف شد");
          setTimeout(() => setOrderMessage(""), 2500);
        } else {
          setOrderMessage(data.message || "خطا در حذف سفارش");
        }
      } catch {
        setOrderMessage("خطا در برقراری ارتباط با سرور");
      }
    }
  };

  // نمایش شرح سفارش (در صورت json بودن)
  const renderOrderDescription = (description) => {
    if (!description) return "-";
    let descObj;
    try {
      descObj = JSON.parse(description);
    } catch {
      return description;
    }
    return (
      <div style={{ textAlign: "right", maxWidth: 200 }}>
        {descObj.note && <div>یادداشت: {descObj.note}</div>}
        {descObj.cardNumber && <div>کارت: {descObj.cardNumber}</div>}
        {descObj.trackingNumber && <div>پیگیری: {descObj.trackingNumber}</div>}
        {descObj.paymentDate && <div>تاریخ پرداخت: {descObj.paymentDate}</div>}
        {descObj.paymentSlip && (
          <div>
            فیش واریز:
            <img
              src={descObj.paymentSlip}
              alt="فیش واریز"
              style={{ maxWidth: 70, border: "1px solid #eee", marginTop: 4, display: "block" }}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="order-list-container">
      <div className="order-list-header">
        <h2>لیست سفارشات</h2>
        <button
          className="add-order-button"
          onClick={() => navigate("/admin/orders/add")}
        >
          افزودن سفارش جدید
        </button>
      </div>

      <div className="order-search-box">
        <form onSubmit={handleSearch}>
          <input
            type="text"
            value={searchInput}
            onChange={e => setSearchInput(e.target.value)}
            placeholder="جستجو بر اساس نام کاربر یا نوع سرویس..."
          />
          <button type="submit">جستجو</button>
          {searchQuery && (
            <button type="button" onClick={clearSearch}>پاک</button>
          )}
        </form>
      </div>

      {orderMessage && (
        <div className={`alert ${orderMessage.includes("موفق") ? "alert-success" : "alert-danger"}`}>
          {orderMessage}
        </div>
      )}
      {error && (
        <div className="error">{error}</div>
      )}

      {loading ? (
        <div className="loading">در حال بارگذاری...</div>
      ) : orders.length === 0 ? (
        <div className="no-orders-found">سفارشی وجود ندارد.</div>
      ) : (
        <div className="table-responsive">
          <table className="orders-table">
            <thead>
              <tr>
                <th onClick={() => handleSort("id")}>#</th>
                <th>کاربر</th>
                <th>نوع سرویس</th>
                <th style={{minWidth:100}}>شرح سفارش</th>
                <th onClick={() => handleSort("price")}>مبلغ</th>
                <th onClick={() => handleSort("status")}>وضعیت</th>
                <th onClick={() => handleSort("created_at")}>تاریخ ثبت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(order => (
                <tr key={order.id}>
                  <td>{order.id}</td>
                  <td>{order.user_fullname}</td>
                  <td>{serviceTypeLabels[order.service_type] || order.service_type}</td>
                  <td>{renderOrderDescription(order.description)}</td>
                  <td>
                    <span className="price-badge">
                      {Number(order.price).toLocaleString()} تومان
                    </span>
                  </td>
                  <td>
                    <span className={`status-badge ${getStatusColor(order.status)}`}>
                      {translateStatus(order.status)}
                    </span>
                  </td>
                  <td>
                    {order.created_at
                      ? new Date(order.created_at).toLocaleDateString("fa-IR")
                      : "-"}
                  </td>
                  <td>
                    <div className="order-actions">
                      <button
                        className="edit-order-btn"
                        onClick={() => handleEditOrder(order)}
                        title="ویرایش"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button
                        className="delete-order-btn"
                        onClick={() => handleDeleteOrder(order.id)}
                        title="حذف"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            قبلی
          </button>
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i + 1}
              onClick={() => setCurrentPage(i + 1)}
              className={currentPage === i + 1 ? "active" : ""}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
          >
            بعدی
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderListManagement;
